import { TrashLight } from '@profgeosoft-ui/icons';
import { Button } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import type { BasicParametersStore } from '../BasicParameters.store';
import type { ParameterLine } from '../ParameterLine.store';

import styles from '../BasicParameters.module.scss';
import { LogSelect } from '../selects/LogSelect';
import { MnemonicSelect } from '../selects/MnemonicSelect';
import { SupplierSelect } from '../selects/SupplierSelect';

type Props = {
  line: ParameterLine;
  title: string;
  store: BasicParametersStore;
};

export const ParameterRow = observer(function ParameterRow({ line, title, store }: Props) {
  const { t } = useTranslation();

  return (
    <Fragment key={line.parameterType}>
      <div key={`${line.parameterType}-name`} className={styles.parametersSelectionGrid_parameter}>
        {title}
      </div>
      <SupplierSelect line={line} store={store} />
      <LogSelect line={line} store={store} />
      <MnemonicSelect line={line} store={store} />
      <Button
        key={`${line.parameterType}-delete`}
        variant="danger"
        size="s"
        disabled={line.isLoading}
        onClick={() => line.clearParameter()}
      >
        <TrashLight />
      </Button>
      <div key={`${line.parameterType}-noParam`} className={styles.parametersSelectionGrid_warning}>
        {line.isNoParameter && t('settings:noParameter')}
      </div>
    </Fragment>
  );
});
